import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Alert, AlertDescription } from './ui/alert';
import { Button } from './ui/button';

const ErrorMessage = ({ 
  error, 
  onRetry = null, 
  className = '',
  showRetry = true 
}) => {
  return (
    <Alert className={`border-red-200 bg-red-50 ${className}`}>
      <AlertCircle className="h-4 w-4 text-red-600" />
      <AlertDescription className="text-red-800">
        <div className="flex items-center justify-between">
          <span>{error}</span>
          {onRetry && showRetry && (
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              className="ml-4 border-red-300 text-red-700 hover:bg-red-100"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Réessayer
            </Button>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
};

export const ErrorCard = ({ error, onRetry, className = '' }) => (
  <div className={`bg-white rounded-xl shadow-lg p-8 text-center ${className}`}>
    <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
    <h3 className="text-lg font-semibold text-gray-900 mb-2">
      Erreur de chargement
    </h3>
    <p className="text-gray-600 mb-4">{error}</p>
    {onRetry && (
      <Button onClick={onRetry} variant="outline" className="text-red-600 border-red-600">
        <RefreshCw className="w-4 h-4 mr-2" />
        Réessayer
      </Button>
    )}
  </div>
);

export default ErrorMessage;